

const tealiumProfiles = {
  adelaidenow: 'adv',
  adv: 'adv',
  cairnspost: 'cairns',
  cp: 'cairns',
  couriermail: 'tcm',
  cm: 'tcm',
  dailytelegraph: 'dt',
  dt: 'dt',
  heraldsun: 'hwt',
  hs: 'hwt',
  geelongadvertiser: 'gea',
  ga: 'gea',
  goldcoastbulletin: 'gcb',
  gcb: 'gcb',
  mercury: 'mercury',
  merc: 'mercury',
  ntnews: 'ntn',
  ntn: 'ntn',
  perthnow: 'pn',
  townsvillebulletin: 'tvb',
  tb: 'tvb',
  weeklytimesnow: 'wtn',
  wtn: 'wtn',
  thechronicle: 'twc',
  twc: 'twc',
  'xyz': 'dt',
  news: 'news',
  nca: 'news',
  aa: 'adv',
  taus: 'taus',
};

const tealiumEnvs = {
  dev: 'dev',
  sit: 'dev',
  uat: 'qa',
  prod: 'prod',
};

function getTealiumProfile(site) {
  const tealiumProfile = tealiumProfiles[(site || '').toLowerCase()] || null;
  return tealiumProfile ? tealiumProfile : '';
}

function getTealiumEnv(env) {
  return tealiumEnvs[env] || 'dev';
}

function getUtagUrl(envData) {
  const { site, env, type } = envData;

  // const profile = type === 'podcast' ? 'audio' : getTealiumProfile(site);
  const profile = getTealiumProfile(site);
  const tealiumEnv = getTealiumEnv(env);
  const tealiumUrl = `https://tags.tiqcdn.com/utag/newsltd/${ profile }/${ tealiumEnv }/utag.js`;

  console.log('tealium getUtagUrl', profile, site, tealiumEnv, tealiumUrl);

  if (!profile) return;
  return tealiumUrl;
}

// function formatDate(moment, dateString) {
// 	if (moment, dateString) {
// 		return moment(dateString).format('YYYY-MM-DD HH:mm:ss');
// 	}
// 	return '';
// }

function escapeTealium(str = '') {
  return str.replace(/('|\u2018|\u2019)/g, '\\\'').replace(/(<br>|<br \/>)|\r|\n/g, ' ');
}


export default function tealium(article) {
  if (!article) return console.error('no envData received from app webview');

  console.log('tealium function', article);

  const utagUrl = getUtagUrl(article);
  if (!utagUrl) return console.error('no utag url for masthead');

  const utagSyncUrl = utagUrl.slice(0,-2) + 'sync.js';

  // Set paid status of content
  let paidStatus = 'none';

  if (article.accessType === 'PREMIUM') {
    paidStatus = 'restricted';
  } else if (article.accessType === 'NON_PREMIUM') {
    paidStatus = 'free';
  }

  // Determine content type
  let netContentType = article.hasVideos ? 'video+' : '';
  netContentType += article.commentsAllowed ? 'comments+' : '';
  netContentType += 'edtool+story';

  // if (article.isBlog) netContentType = 'blogs';

  // reduce route to net_sec values
  const sections = (article.route || '').split('/').reduce((sectionObject, section, index) => ({
    ...sectionObject,
    [`net_sec${ index + 1 }`]: `${ escapeTealium(section) }`
  }), {});

  // populate utag data
  const utag_data = {
    net_sec1: escapeTealium(article.section),
    net_content_type: `${ netContentType }`,
    net_article_id: article.capiId,
    net_article_headline: escapeTealium(article.title),
    net_article_byline: article.byline,
    net_article_source: article.originalSource,
    net_article_date: article.dateLive,
    net_article_updated_time: article.dateUpdated,
    net_pn: escapeTealium(article.title),
    responsive_platform: 'mobile',
    net_platform: article.channel,
    pc_pcsid: article.userId, // used for ThinkID sites
    // net_site_uid:                     article.userId,  // used for Gigya sites
    pc_conttyperule: `${ paidStatus }`,
    pc_memtype: article.userAccessLevel,
    ...sections
  };

  console.log('prepropulated utag data for tealium', utag_data);

  window.utag_data = {
    ...(window.utag_data || {}),
    ...utag_data
  };
  
  window.utag_data.disable_pageview = true;

  loadScript(utagSyncUrl);
  loadScript(utagUrl);

}


function loadScript(src) {
  (function(d, s) {
    var j = document.createElement(s);
    j.type = 'text/javascript';
    j.src = src;
    d.getElementsByTagName('head')[0].appendChild(j);
  }(document, 'script'));
}

// accessType: "NON_PREMIUM"
// byline: ""
// capiId: "d886ff5b5bf7c88a5f0ceb9fcc375d12"
// commentsAllowed: false
// dateLive: "2019-08-14 23:26:06 +0000"
// dateUpdated: "2019-08-14 23:14:13 +0000"
// env: "uat"
// hasVideos: false
// isBlog: true
// originalSource: "The Daily Telegraph"
// platform: "ios"
// route: "sport/sport"
// section: "sport"
// site: "dt"
// title: "Crazy man tests embeds on Masthead apps"
// userAccessLevel: "subscriber"
// userId: "37639277"
